import React from "react";
import { Box, Typography, Grid, Paper, IconButton, Tabs, Tab } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";

const days = ["07 Monday", "08 Tuesday", "09 Wednesday", "10 Thursday", "11 Friday", "12 Saturday"];
const timeSlots = ["8:00 am - 8:00 pm", "8:00 pm - 8:00 am", "8:00 am - 11:00 pm"];

export default function EmployeeSchedule() {
  const [selectedShift, setSelectedShift] = React.useState(0);

  const handleShiftChange = (event, newValue) => {
    setSelectedShift(newValue);
  };

  return (
    <Box sx={{ pl: 4, pr: 4, ml: 2 }}>
      <Box>
        <Typography sx={{ fontSize: "24px", fontWeight: "bold", color: "black" }}>Employee Schedule</Typography>
      </Box>

      <Tabs value={selectedShift} onChange={handleShiftChange} sx={{ mb: 2 }}>
        <Tab label='Day Shift' />
        <Tab label='Night Shift' />
        <Tab label='Sleep in' />
      </Tabs>

      <Box border={1} borderColor='divider' borderRadius={2} p={2}>
        <Box display='flex' justifyContent='space-between' alignItems='center' mb={2}>
          <Typography>Today</Typography>
          <Typography>April 2025</Typography>
        </Box>

        <Grid container>
          <Grid item xs={2.5}>
            <Box>
              {timeSlots.map((slot, index) => (
                <Box key={index} height={100} borderBottom={1} display='flex' alignItems='center' px={1}>
                  <Typography variant='body2'>{slot}</Typography>
                </Box>
              ))}
            </Box>
          </Grid>

          <Grid item xs={9.5}>
            <Grid container>
              {days.map((day, dayIndex) => (
                <Grid item xs={2} key={dayIndex} borderLeft={1}>
                  <Box height={100} borderBottom={1} display='flex' justifyContent='center' alignItems='center'>
                    <Typography variant='body2'>{day}</Typography>
                  </Box>

                  {[1, 2].map((row) => (
                    <Box key={row} height={100} borderBottom={1} />
                  ))}

                  {day.includes("09") && (
                    <Box height={100} p={1}>
                      <Paper elevation={3} sx={{ p: 1, position: "relative" }}>
                        <IconButton size='small' sx={{ position: "absolute", top: 2, right: 2 }}>
                          <EditIcon fontSize='small' />
                        </IconButton>
                        <Typography variant='body2' fontWeight='bold'>
                          Sara Smith
                        </Typography>
                        <Typography variant='caption'>Deputy Manager</Typography>
                      </Paper>
                    </Box>
                  )}
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}
